import {Component, Input, OnInit} from '@angular/core';
import {ContactRequestResponseModel} from "../../../../../shared/model/response/event/contactRequestResponse.model";
import {EventResponse} from "../../../../../shared/model/response/event/event-response.model";
import {PageInfo} from "../../../../../shared/model/response/page-info.model";
import {ContactRequestService} from "../../../../../service/api/contact-request.service";
import {ApiResponse} from "../../../../../shared/model/response/ApiResponse";
import {PaginatorState} from "primeng/paginator";
import {take} from "rxjs";
import {ModalService} from "../../../../../service/modal.service";
import {ContactRequestFilterModel} from "../../../../../shared/model/request/contact-request-filter.model";
import {MessagesEnum} from "../../../../../shared/enums/messages.enum";
import {MessageToastService} from "../../../../../service/message-toast.service";

@Component({
    selector: 'app-contact-request-list',
    templateUrl: './contact-request-list.component.html',
    standalone: false
})
export class ContactRequestListComponent implements OnInit {

  @Input('event') event: EventResponse

  public contactRequests: ContactRequestResponseModel[]
  public contactRequestPageInfo: PageInfo

  constructor(
    private contactRequestService: ContactRequestService,
    private modalService: ModalService,
    private messageService: MessageToastService) {

    this.contactRequests = []
  }

  ngOnInit(): void {
    this.loadContactRequestService(this.event.id, 0)
  }

  //load contact requests lists by page
  loadContactRequestService(eventId: number, page: number) {
    const filter: ContactRequestFilterModel = {}
    filter.eventId = eventId;
    this.contactRequestService.getAll(page, filter).subscribe({
      next: (response: ApiResponse<ContactRequestResponseModel[]>) => {
        this.contactRequests = response.data
        this.contactRequestPageInfo = response.pageInfo
      }
    })
  }

  onPageChange($event: PaginatorState) {
    //todo implement?
  }

  answerContactRequest(contactRequestId: number, answer: boolean) {
    this.modalService.simpleConfirmation({
      message: answer ? MessagesEnum.acceptContactRequest : MessagesEnum.rejectContactRequest
    }).then(confirmed => {
      if (confirmed) {
        this.apiAnswerContactRequest(contactRequestId, answer)
      }
    })
  }

  apiAnswerContactRequest(contactRequestId: number, answer: boolean) {

    const index = this.contactRequests.findIndex(el => el.id == contactRequestId)

    this.contactRequestService.answerContactRequest(contactRequestId, answer)
      .pipe(take(1))
      .subscribe({
        next: (response: ApiResponse<ContactRequestResponseModel>) => {
          this.messageService.success(response.message)
          this.contactRequests.splice(index, 1)
        },
        error: (response: ApiResponse<ContactRequestResponseModel>) => {
          this.messageService.error(response.message)
        }
      })
  }

}
